import { Flex } from 'antd';

import {
  useAppSelector,
  useDeptProjectName,
  useRequestTypeFinderById,
  useStatusFinderByNum,
  useUserPermissions,
  useWorkLocationType,
} from '@Hooks/index';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import {
  getAttendanceReasonsDict,
  getCompaniesDictSelector,
} from '@Store/selectors/dictionarySelector';
import { TypeDict } from '@Types/index';
import { Status } from '@Components/Base';
import fieldSource from '../FieldSource';

import { EditAction, FooterActions } from './components';

import styles from './view-mobile-form.module.css';

interface RequestViewMobileFormProps {
  onEdit: (recordKey: string) => void;
  onDeleteRequest: (requestNo: string) => void;
  onSubmitRequest: (requestNo: string) => void;
  onCancelRequest: (requestNo: string) => void;
}

const RequestViewMobileForm: React.FC<RequestViewMobileFormProps> = ({
  onEdit,
  onDeleteRequest,
  onSubmitRequest,
  onCancelRequest,
}) => {
  const companies = useAppSelector(getCompaniesDictSelector);
  const reasonsType = useAppSelector(getAttendanceReasonsDict);
  const permissions = useUserPermissions();

  const { findStatus } = useStatusFinderByNum('Attendance');
  const { findRequestType } = useRequestTypeFinderById('Attendance');
  const { findWorkLocationType } = useWorkLocationType();
  const { findDeptProjName } = useDeptProjectName();
  const requestId = useAppSelector(getModalRecordKey);
  const { data } = useGetHrmRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });

  if (!data) return null;

  const statusRequest = findStatus(data?.reqStatusId)?.codeDesc || '';

  const findReasonType = (reasonId: number): TypeDict | undefined =>
    reasonsType.find((item) => item.codeNum === reasonId);

  return (
    <Flex vertical>
      <div className={styles.viewMobileForm}>
        {fieldSource({
          data,
          companies,
          findRequestType,
          findWorkLocationType,
          findDeptProjName,
          findReasonType,
        }).map((item) => (
          <div className={styles.viewMobileItem} key={item.label}>
            <span>{item.label}</span>
            {item.label === 'Status' ? (
              <Status
                className={styles.viewItemValue}
                text={findStatus(Number(item.value))?.codeDesc || ''}
              />
            ) : (
              <span className={styles.viewMobileItemValue}>{item.value}</span>
            )}
          </div>
        ))}
      </div>
      <EditAction handleEdit={() => onEdit(requestId)} status={statusRequest} />
      <FooterActions
        handleDeleteRequest={() => onDeleteRequest(requestId)}
        handleSubmitRequest={() => onSubmitRequest(requestId)}
        handleCancelRequest={() => onCancelRequest(requestId)}
        disabledCancelForm={!permissions.can('Cancel', 'Attendance')}
        disabledDeleteForm={!permissions.can('Delete', 'Attendance')}
        disabledSubmitForm={!permissions.can('Submit', 'Attendance')}
        status={statusRequest}
      />
    </Flex>
  );
};

export default RequestViewMobileForm;
